import { ReactNode } from 'react';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Button } from '@frekuent/orbit/components';
import { useStore } from '@/legacy/store/zustand';
import { CloseIcon } from '../Icons';

type OffcanvasProps = {
	id: string;
	children: ReactNode;
	position?: 'left' | 'right';
	className?: string;
	width?: string;
	otherActions?: ReactNode;
};

const Offcanvas = ({
	id,
	children,
	position = 'right',
	className,
	width = 'w-[32rem]',
	otherActions,
}: OffcanvasProps) => {
	const { t } = useTranslation();
	const { offcanvas, closeOffcanvas } = useStore();
	const isOpen = offcanvas === id;

	return (
		<div className={clsx('fixed inset-0 z-50', isOpen ? 'block' : 'hidden')}>
			<div
				className='fixed inset-0 bg-black bg-opacity-50'
				onClick={closeOffcanvas}
			></div>

			<motion.div
				initial={{ x: position === 'right' ? '100%' : '-100%' }}
				animate={{ x: isOpen ? 0 : position === 'right' ? '100%' : '-100%' }}
				transition={{ type: 'tween', duration: 0.3 }}
				className={clsx(
					'fixed top-0 h-full bg-light shadow-xl flex flex-col gap-4 px-10 py-8',
					position === 'right' ? 'right-0' : 'left-0',
					width,
					className,
				)}
			>
				<div className='self-end flex items-center justify-end w-full gap-2'>
					{otherActions ? <div className='flex items-center gap-2'>{otherActions}</div> : null}
					<Button
						type='button'
						onClick={closeOffcanvas}
						size='icon'
						aria-label={t('common.close')}
						className='text-icon-cuaternary'
					>
						<CloseIcon />
					</Button>
				</div>
				<div className='flex-1 overflow-y-auto flex flex-col gap-6'>{children}</div>
			</motion.div>
		</div>
	);
};

export default Offcanvas;
